export default "__VITE_ASSET__wKSw8Nim__"